import { Box } from "@mui/material";
import HierarchyType from "@/src/_types/Page/hierarchy";
import NextLink from "next/link";
import Kicker from "@/src/components/common/broadsheet/kicker";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

const Hierarchy = ({
  hierarchies,
  journal,
  pageSlug,
}: {
  hierarchies: HierarchyType[];
  journal: Journal;
  pageSlug: string;
}) => {
  const hrefFor = (page: HierarchyType) =>
    journal.is_main_site
      ? `${page?.path}`
      : `/${journal.journal_url}${page?.path}`;

  const renderPages = (pages: HierarchyType[], depth = 0) => (
    <Box component="ul" sx={{ listStyle: "none", m: 0, p: 0 }}>
      {pages.map((page, index) => {
        const current = page.slug === pageSlug;

        return (
          <Box component="li" key={index} sx={{ m: 0 }}>
            <Box
              component={NextLink}
              href={hrefFor(page)}
              aria-current={current ? "page" : undefined}
              sx={{
                display: "block",
                fontFamily: FONT_UI,
                fontSize: "0.65rem",
                fontWeight: current ? 700 : 400,
                lineHeight: 0.9,
                color: current ? "custom.link" : "custom.inkMuted",
                textDecoration: "none",
                borderLeft: "2px solid",
                borderColor: current ? "custom.link" : "custom.ruleHairline",
                pl: `${0.625 + Math.min(depth, 2) * 0.5}rem`,
                paddingBlock: "0.4375rem",
                "&:hover": {
                  color: "custom.link",
                  borderColor: "custom.link",
                },
              }}
            >
              {page.title}
            </Box>
            {page.childes && page.childes.length > 0
              ? renderPages(page.childes, depth + 1)
              : null}
          </Box>
        );
      })}
    </Box>
  );

  if (!hierarchies || hierarchies.length === 0) return null;

  return (
    <Box component="nav" aria-label="In this section">
      <Kicker sx={{ mb: 0.375 }}>In this section</Kicker>
      {renderPages(hierarchies)}
    </Box>
  );
};

export default Hierarchy;
